/*
 * WAOCON: KEIKA「通常フロー版」の商品ページ・カートに、定期便・予約販売・ポイント欄を合わせる
 * 1) 【定期便】フォーム（form.kp-add[data-plan]）に「お届け周期」の選択欄を足す。
 *    選んだプランを form の data-plan に入れる（カート追加はコーダーさんの既存処理がこの値を読む）。
 *    直前の価格表示（.meta）も、選んだプランの価格に書き換える。
 * 2) RuffRuff 予約販売のルールを、通常購入フォームのボタンに反映する（予約する／受付終了・商品メッセージ）。
 * 3) TWINKLE VIVI のミニサイズ誘導バナーを、ミニサイズの商品ページへつなぐ。
 * 4) カート：どこポイのポイント欄（アプリセクション）を、小計の枠の中（CHECKOUT の上）へ移す。
 * 無効化: sections/footer-group.json から waocon_subscription を外す。
 */
(function () {
  "use strict";
  if (window.__waoconFlow) return;
  window.__waoconFlow = true;

  var yen = function (cents) { return "¥" + Math.round(cents / 100).toLocaleString("ja-JP"); };
  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function days(name) { var n = parseInt(String(name).replace(/[^\d]/g, ""), 10); return isNaN(n) ? 9999 : n; }

  /* ---------- 1) 定期便の周期選択 ---------- */
  function cycle(p) {
    Array.prototype.forEach.call(document.querySelectorAll("form.kp-add"), function (f) {
      if (!f.dataset.plan || f.querySelector(".waocon-cycle")) return;
      var idInput = f.querySelector('input[name="id"]');
      var vid = idInput ? parseInt(idInput.value, 10) : 0;
      var variant = p.variants.filter(function (v) { return v.id === vid; })[0] || p.variants[0];
      var group = p.selling_plan_groups.filter(function (g) {
        return g.selling_plans.some(function (s) { return String(s.id) === f.dataset.plan; });
      })[0];
      if (!group || !variant) return;
      var price = {};
      (variant.selling_plan_allocations || []).forEach(function (a) { price[a.selling_plan_id] = a.price; });
      var plans = group.selling_plans.filter(function (s) { return price[s.id] != null; })
        .sort(function (a, b) { return days(a.name) - days(b.name); });
      if (plans.length < 2) return;

      var wrap = document.createElement("div");
      wrap.className = "waocon-cycle";
      wrap.style.cssText = "display:flex;flex-direction:column;gap:8px;margin:0 0 18px";
      var lab = document.createElement("label");
      lab.textContent = "お届け周期";
      lab.style.cssText = "font-size:13px;letter-spacing:.1em";
      var sel = document.createElement("select");
      sel.setAttribute("aria-label", "お届け周期");
      sel.style.cssText = "width:100%;height:46px;border:0;border-radius:0;background:#f9f9f9;padding:0 14px;" +
        "font-family:'Zen Kaku Gothic New',sans-serif;font-size:15px;letter-spacing:.06em;color:rgb(42,43,45)";
      plans.forEach(function (s) {
        var o = document.createElement("option");
        o.value = String(s.id);
        o.textContent = s.name;
        if (String(s.id) === f.dataset.plan) o.selected = true;
        sel.appendChild(o);
      });
      lab.htmlFor = sel.id = "waocon-cycle-" + Math.random().toString(36).slice(2, 8);
      wrap.appendChild(lab);
      wrap.appendChild(sel);
      var anchor = f.querySelector(".qrow") || f.querySelector(".qty");
      f.insertBefore(wrap, anchor || f.firstChild);

      var meta = f.previousElementSibling && f.previousElementSibling.classList.contains("meta") ? f.previousElementSibling : null;
      var show = function () {
        f.dataset.plan = sel.value;
        var pr = price[sel.value];
        if (meta && pr != null) meta.innerHTML = meta.innerHTML.replace(/[¥￥][\d,]+/, yen(pr));
      };
      sel.addEventListener("change", show);
      show();
    });
  }

  /* ---------- 2) RuffRuff 予約販売 ---------- */
  var CLOSED_LABEL = "受付終了";
  function mode(v) {
    v = String(v || "").toLowerCase();
    if (v.indexOf("disable") === 0) return "disabled";
    if (v.indexOf("hid") === 0) return "hidden";
    return "visible";
  }
  function evaluate(rule, customer, available) {
    var now = new Date();
    if (rule.startsAt && now < new Date(rule.startsAt)) return "before";
    if (rule.endsAt && now > new Date(rule.endsAt)) return "after";
    var local = new Date(now.getTime() + (rule.timezoneOffsetMinutes || 0) * 60000);
    if (rule.frequency === "weekly" && rule.weekdays && rule.weekdays.indexOf(local.getUTCDay()) < 0) return "notmet";
    if (rule.frequency === "monthly" && rule.dates && rule.dates.indexOf(local.getUTCDate()) < 0) return "notmet";
    if (rule.inventoryConditionMet === false) return "notmet";
    if (available === false) return "notmet";   // Shopify の在庫切れ（上限数に到達）
    if (rule.requireAccount && !(customer && customer.hasAccount)) return "notmet";
    if (rule.customerTags && rule.customerTags.length) {
      var tags = (customer && customer.tags) || [];
      var hit = rule.customerTags.filter(function (t) { return tags.indexOf(t) >= 0; }).length;
      if (!(rule.customerTagsCondition === "or" ? hit > 0 : hit === rule.customerTags.length)) return "notmet";
    }
    return "met";
  }
  function actionFor(rule, state) {
    if (state === "met") return { mode: "enabled", text: rule.buttonName, message: rule.productMessage };
    var a;
    if (state === "before" && rule.actionsBeforeStartsAtEnabled)
      a = { mode: mode(rule.buttonConditionBeforeStartsAt), text: rule.buttonNameBeforeStartsAt, message: rule.productMessageBeforeStartsAt };
    else if (state === "after" && rule.actionsAfterEndsAtEnabled)
      a = { mode: mode(rule.buttonConditionAfterEndsAt), text: rule.buttonNameAfterEndsAt, message: rule.productMessageAfterEndsAt };
    else
      a = { mode: mode(rule.buttonCondition), text: rule.buttonNameIfNotMet, message: rule.productMessageIfNotMet };
    // 期間外・条件外は、文言の指定がなければ押せない「受付終了」にする（テスト用ストアと同じ）
    if (a.mode === "visible") a.mode = "disabled";
    if (a.mode === "disabled" && !a.text) a.text = CLOSED_LABEL;
    return a;
  }
  function plain(html) {
    if (!html) return "";
    var doc = new DOMParser().parseFromString(String(html).replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>\s*<p[^>]*>/gi, "\n"), "text/html");
    return (doc.body.textContent || "").trim();
  }
  function preorder(p) {
    var data = readJson("ruffruff-pre-order-product-json");
    if (!data || !data.variants) return;
    Array.prototype.forEach.call(document.querySelectorAll("form.kp-add"), function (f) {
      if (f.dataset.plan) return;                       // 定期便フォームは対象外
      var idInput = f.querySelector('input[name="id"]');
      var vid = idInput ? String(idInput.value) : String(data.defaultVariantId);
      var v = data.variants[vid] || data.variants[String(data.defaultVariantId)];
      var rule = v && v.preOrderRule;
      if (!rule) return;
      var variant = p.variants.filter(function (x) { return String(x.id) === vid; })[0] || p.variants[0];
      var act = actionFor(rule, evaluate(rule, readJson("ruffruff-pre-order-customer-json"), variant && variant.available));
      var btn = f.querySelector(".cta");
      if (!btn) return;
      if (act.mode === "hidden") { f.style.display = "none"; return; }
      btn.disabled = act.mode !== "enabled" || (variant && variant.available === false);
      if (act.text) btn.textContent = act.text;
      var msg = plain(act.message);
      var box = f.querySelector(".waocon-preorder-msg");
      if (msg) {
        if (!box) {
          box = document.createElement("p");
          box.className = "waocon-preorder-msg";
          box.style.cssText = "margin:12px 0 0;font-size:13px;line-height:1.7;letter-spacing:.04em;white-space:pre-wrap";
          btn.parentNode.insertBefore(box, btn.nextSibling);
        }
        box.textContent = msg;
      } else if (box) box.remove();
    });
  }

  /* ---------- 3) ミニサイズ誘導バナー ---------- */
  function miniLink() {
    var card = Array.prototype.filter.call(document.querySelectorAll("a.card"), function (a) { return /ミニ/.test(a.textContent); })[0];
    var url = card ? card.getAttribute("href") : "/products/twinkle-vivi%E3%83%9F%E3%83%8B%E3%82%B5%E3%82%A4%E3%82%BA";
    Array.prototype.forEach.call(document.querySelectorAll("a.mini"), function (a) {
      if (a.getAttribute("href") === "/collections/all") a.setAttribute("href", url);
    });
  }

  /* ---------- 4) カートのポイント欄 ---------- */
  function cartPoints() {
    var sum = document.querySelector(".kc-sum");
    var sec = document.querySelector('[id$="__17906759550a9fd7f3"]');
    if (!sum || !sec) return !document.querySelector(".kc-sum") ? true : false;
    if (sec.parentNode === sum) return true;
    sec.style.margin = "20px 0 0";
    // Dawn のスクロール表示アニメーション用クラスが付くと、この独自ページでは表示されないままになるため外す
    Array.prototype.forEach.call(sec.querySelectorAll(".scroll-trigger"), function (e) {
      e.classList.remove("scroll-trigger", "animate--slide-in");
    });
    var co = sum.querySelector(".kc-co");
    sum.insertBefore(sec, co || null);
    return true;
  }

  function start() {
    if (/\/products\//.test(location.pathname)) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      fetch("/products/" + m[1] + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (p) { cycle(p); preorder(p); miniLink(); })
        .catch(function () {});
    } else if (/\/cart\/?$/.test(location.pathname)) {
      var n = 0, t = setInterval(function () { if (cartPoints() || ++n > 40) clearInterval(t); }, 250);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
